module.exports = __webpack_public_path__ + "img/图片5.33f2e016.png";